import type { NavigationState } from 'src/redux/navigation/slice';
import { PageType } from 'src/types/navigation';

export const isCategoryPage = (pageType: NavigationState['pageType']) =>
  pageType === PageType.Category;

export const isPartnerPage = (pageType: NavigationState['pageType']) =>
  pageType === PageType.Partner;

export const isSearchPage = (pageType: NavigationState['pageType']) => pageType === PageType.Search;

export const isTaxonomyPage = (pageType: NavigationState['pageType']) =>
  pageType === PageType.Taxonomy;

export const getTaxonomyLevelFromPathname = (pathname: string): string => {
  const taxonomyPath = pathname.split('/-/')[0];
  // e.g. /shop/all/jewellery -> segments: ['shop', 'all', 'jewellery'] (length 3) -> level 1
  const pathSegments = taxonomyPath.split('/').filter(Boolean);
  const level = Math.max(0, pathSegments.length - 2);
  return `attributes.pim_product_type_level_${level}`;
};
